/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Info_Unlock_TextInputs */

const en_explorer_info_unlock_text = /** @type {(inputs: Explorer_Info_Unlock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Do you want to unlock "${i?.name}"? This will allow others to modify it.`)
};

const fr_explorer_info_unlock_text = /** @type {(inputs: Explorer_Info_Unlock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voulez-vous deverrouiller "${i?.name}" ? Cela permettra aux autres de le modifier.`)
};

const de_explorer_info_unlock_text = /** @type {(inputs: Explorer_Info_Unlock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie "${i?.name}" entsperren? Dadurch können andere es bearbeiten.`)
};

const it_explorer_info_unlock_text = /** @type {(inputs: Explorer_Info_Unlock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vuoi sbloccare "${i?.name}"? Questo permetterà ad altri di modificarlo.`)
};

const ru_explorer_info_unlock_text = /** @type {(inputs: Explorer_Info_Unlock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы хотите разблокировать "${i?.name}"? Это позволит другим пользователям изменять его.`)
};

const es_explorer_info_unlock_text = /** @type {(inputs: Explorer_Info_Unlock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Quieres desbloquear "${i?.name}"? Esto permitirá que otros puedan modificarlo.`)
};

const zh_cn2_explorer_info_unlock_text = /** @type {(inputs: Explorer_Info_Unlock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您是否要解锁“${i?.name}”？这将允许其他人对其进行修改。`)
};

const ja_explorer_info_unlock_text = /** @type {(inputs: Explorer_Info_Unlock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`「${i?.name}」のロックを解除しますか？これにより、他のユーザーが変更できるようになります。`)
};

const hi_explorer_info_unlock_text = /** @type {(inputs: Explorer_Info_Unlock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`क्या आप "${i?.name}" को अनलॉक करना चाहते हैं? इससे दूसरों को इसे संशोधित करने की अनुमति मिल जाएगी।`)
};

const pt_pt2_explorer_info_unlock_text = /** @type {(inputs: Explorer_Info_Unlock_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deseja desbloquear "${i?.name}"? Isso permitirá que outros o modifiquem.`)
};

/**
* | output |
* | --- |
* | "Do you want to unlock \"{name}\"? This will allow others to modify it." |
*
* @param {Explorer_Info_Unlock_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_unlock_text = /** @type {((inputs: Explorer_Info_Unlock_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Unlock_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_unlock_text(inputs)
	if (locale === "de") return de_explorer_info_unlock_text(inputs)
	if (locale === "it") return it_explorer_info_unlock_text(inputs)
	if (locale === "ru") return ru_explorer_info_unlock_text(inputs)
	if (locale === "es") return es_explorer_info_unlock_text(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_unlock_text(inputs)
	if (locale === "ja") return ja_explorer_info_unlock_text(inputs)
	if (locale === "hi") return hi_explorer_info_unlock_text(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_unlock_text(inputs)
	return en_explorer_info_unlock_text(inputs)
});